import { useParams } from "react-router-dom";

import { MobileSubNavItem } from "./Mobile";

import { Feature } from "@hire/schema";
import { useAuthorizations } from "@hire/providers/authorization";

export function SettingsSubNav({ onClick }: { onClick?: () => void }) {
  const { companySlug } = useParams<"companySlug">();

  const { features } = useAuthorizations([
    Feature.TeamMembers,
    Feature.ViewSourcingTemplates,
    Feature.ViewRejectionTemplates,
    Feature.SsoSettings,
  ]);

  return (
    <>
      <MobileSubNavItem
        to={`/${companySlug}/settings/billing`}
        onClick={onClick}
      >
        Billing
      </MobileSubNavItem>
      {features.get(Feature.TeamMembers)?.granted && (
        <MobileSubNavItem
          to={`/${companySlug}/settings/team`}
          onClick={onClick}
        >
          Team members
        </MobileSubNavItem>
      )}
      {(features.get(Feature.ViewSourcingTemplates)?.granted ||
        features.get(Feature.ViewRejectionTemplates)?.granted) && (
        <MobileSubNavItem
          to={`/${companySlug}/settings/templates`}
          onClick={onClick}
        >
          Message templates
        </MobileSubNavItem>
      )}
      <MobileSubNavItem to={`/${companySlug}/settings/ats`} onClick={onClick}>
        ATS integration
      </MobileSubNavItem>
      {features.get(Feature.SsoSettings)?.granted && (
        <MobileSubNavItem to={`/${companySlug}/settings/sso`} onClick={onClick}>
          SSO settings
        </MobileSubNavItem>
      )}
    </>
  );
}
